export enum ChipVariants {
  Filled = "Filled",
  Outline = "Outline",
  Assistive = "Assistive",
  Filter = "Filter",
  Suggestive = "Suggestive",
}
